<div class="row">
    <div class="col-12 align-self-center">
        <div class="form-group text-center">
            <label for="entrada-input"><b>Entrada</b></label>
            <input id="entrada-input" (ngModelChange)="change($event)" [(ngModel)]="entrada" placeholder="000000" type="text" name="entrada" class="form-control">
            <p class="text-danger" *ngIf="error">{{error}}</p>
        </div>
    </div>
</div>
